/** Retorna quantos dias úteis (seg-sex) faltam até o fim do mês, incluindo hoje se for útil. */
export function workdaysRemaining(refDate = new Date()) {
  const year = refDate.getFullYear();
  const month = refDate.getMonth();
  const today = refDate.getDate();
  const last = new Date(year, month + 1, 0).getDate();
  let count = 0;
  for (let d = today; d <= last; d++) {
    const dow = new Date(year, month, d).getDay();
    if (dow !== 0 && dow !== 6) count++;
  }
  return count;
}
